export const EARNED_CREDITS_PATH = '/account/earn-credits';
export const GROCERY_PATH = '/grocery';
export const IOS_MOBILE_PATH = '/ios-app';
export const ANDROID_MOBILE_PATH = '/android-app';
